import { Context as PosContext } from '@squareup/sq-addons-web-sdk';

export type ContextState = {
  posContext: PosContext;
  isPending: boolean; // Whether it is fetching context.
  error?: Error; // Error while fetching context, if any.
};

export const FETCH_CONTEXT = 'FETCH_CONTEXT';
export const FETCH_CONTEXT_FULFILLED = 'FETCH_CONTEXT_FULFILLED';
export const FETCH_CONTEXT_REJECTED = 'FETCH_CONTEXT_REJECTED';

export type FetchContextAction = {
  type: typeof FETCH_CONTEXT;
  payload: {
    getPosContext: () => Promise<PosContext>;
  };
};

export type FetchContextFulfilledAction = {
  type: typeof FETCH_CONTEXT_FULFILLED;
  payload: {
    posContext: PosContext;
  };
};

export type FetchContextRejectedAction = {
  type: typeof FETCH_CONTEXT_REJECTED;
  payload: {
    error: Error;
  };
};

export type ContextActionTypes =
  | FetchContextAction
  | FetchContextFulfilledAction
  | FetchContextRejectedAction;
